<p-toast></p-toast>

<p-sidebar [(visible)]="visible" position="right" [baseZIndex]="10000"
		   (onHide)="cancel()"
		   [style]="{width:'40em'}">
	<ng-template pTemplate="header">Upload Image</ng-template>
	<p-tabMenu [model]="menuItems" [activeItem]="menuItems[0]"></p-tabMenu>

	<div *ngIf="(activeTab === uploadImageTab.Logo && !croppedLogo) || (activeTab === uploadImageTab.Cover && !croppedCover)">
		<input id="idImgInput" type="file" accept="image/*" style="display: none" (change)="fileChangeEvent($event)" />

		<div (click)="handleUploadClick()" style="width: 230px; height: 230px; box-shadow: 0px 3px 6px #3333331A; border: 0.5px solid #0040604D; border-radius: 6px; margin: 50% auto; cursor: pointer">
			<div style="margin: 35% auto;text-align: center">
				<span class="pi pi-image" style="font-size: 50px;"></span>
				<div>Upload image</div>
				<div>Minimum 600x320 pixels</div>
			</div>
		</div>
	</div>
	<div *ngIf="activeTab === uploadImageTab.Logo && croppedLogo">
		<div class="upload-store-img-preview">Preview</div>
		<img src="{{croppedLogo}}" style="max-width: 400px; max-height: 400px;"/>
	</div>
	<div *ngIf="activeTab === uploadImageTab.Cover && croppedCover">
		<div class="upload-store-img-preview">Preview</div>
		<img [src]="croppedCover" style="max-width: 400px; max-height: 400px;"/>
	</div>

	<ng-template pTemplate="footer">
		<div class="flex-row" style="padding: 20px;">
			<div style="margin-left: auto;">
				<button pButton type="button" class="btn-darkblue" label="Save Changes"
						[disabled]="loading" (click)="changeMerchantImage()"
						*ngIf="(activeTab === uploadImageTab.Cover && croppedCover) || (activeTab === uploadImageTab.Logo && croppedLogo)"></button>
			</div>
		</div>
	</ng-template>
</p-sidebar>

<p-dialog header="{{activeTab === uploadImageTab.Logo ? 'App store image' : 'App store cover image'}}" [(visible)]="showImageCropper" [style]="{width: '600px'}">

	<image-cropper [imageChangedEvent]="imageChangedEvent"
				   [maintainAspectRatio]="true"
				   [aspectRatio]="3 / 3"
				   format="png"
				   (imageCropped)="imageCropped($event)"
				   (imageLoaded)="imageLoaded($event)"
				   (cropperReady)="cropperReady()"
				   (loadImageFailed)="loadImageFailed()"
				   *ngIf="activeTab === uploadImageTab.Logo"></image-cropper>
	<image-cropper [imageChangedEvent]="imageChangedEvent"
				   [maintainAspectRatio]="true"
				   [aspectRatio]="4 / 3"
				   format="png"
				   (imageCropped)="imageCropped($event)"
				   (imageLoaded)="imageLoaded($event)"
				   (cropperReady)="cropperReady()"
				   (loadImageFailed)="loadImageFailed()"
				   *ngIf="activeTab === uploadImageTab.Cover"></image-cropper>

	<ng-template pTemplate="footer">
		<div class="flex-row">
			<div style="margin-left: auto">
				<button pButton type="button" label="Cancel" class="p-button-outlined p-button-danger"
						(click)="showImageCropper=false"></button>
			</div>
			<div style="margin-left: 20px;">
				<button pButton type="button" class="btn-darkblue" label="Save Changes"
						[disabled]="loading" (click)="saveCroppedImage()"></button>
			</div>
		</div>
	</ng-template>
</p-dialog>